import { GAUGE_CODES, YES_NO_CODES } from "../../constants/inspectionChecks";
import {
	formatCheckedReading,
	formatM1SpecMeasurement,
} from "../../utils/specUnits";
import type {
	TestShackReportCell,
	TestShackReportColumn,
} from "../models/TestShackReportSectionRev";
import {
	TEST_SHACK_REPORT_STATUS,
	type TestShackReportStatus,
} from "@/pages/products/test-shack/models/TestShackReport";

export const isOutOfSpec = (status: TestShackReportStatus) =>
	status === TEST_SHACK_REPORT_STATUS.OVER ||
	status === TEST_SHACK_REPORT_STATUS.UNDER ||
	status === TEST_SHACK_REPORT_STATUS.NO_GO;

export const formatSpecMeasurement = (
	value: number | null,
	column: TestShackReportColumn,
) =>
	column.valueTypeCode === "A" && !GAUGE_CODES.has(column.code)
		? "-"
		: formatM1SpecMeasurement(value, {
				Code: column.code,
				IsDegrees: column.isDegrees,
			});

export const formatReading = (
	cell: TestShackReportCell | null,
	column: TestShackReportColumn,
) => {
	if (cell === null) return "-";
	if (column.valueTypeCode === "A")
		return cell.checked == null
			? "-"
			: formatCheckedReading(column.code, cell.checked);
	return formatSpecMeasurement(cell.value, column);
};

// Yes/No checks never carry tolerances, so they don't count here.
// Without any spec the card's "No Specification" chip already says it all.
export const showsNoSpecMarkers = (columns: TestShackReportColumn[]) =>
	columns.some((column) => !YES_NO_CODES.has(column.code) && column.hasSpec);

export const hasMissingSpecs = (columns: TestShackReportColumn[]) =>
	showsNoSpecMarkers(columns) && columns.some((column) => !column.hasSpec);
